<template>
  <form class="m-products__sort">
    <select @change="emit('update:modelValue', update($event))" class="a-select"
      :class="{ 'a-select--checkout': props.type === 'checkout' }" :id="id" name="sort">
      <template v-for="(option) in props.options" :key="option.id">
        <option :value="option.id" :selected="props.modelValue?.id === option.id">{{ option.label }}</option>
      </template>
    </select>
    <div class="a-select__icon">
      <svg class="a-icon a-icon--pagination" aria-hidden="true">
        <use href="#chevron-down" />
      </svg>
    </div>
  </form>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid'
import { ref } from 'vue'

export interface Option {
  id: any
  label: string
}

const props = defineProps({
  type: {
    type: String,
  },
  modelValue: {
    type: Object as () => Option | null,
    default: null,
  },
  options: {
    type: Array<Option>,
    default: [],
  }
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: Option | null): void
}>()

const id = ref('select_' + uuidv4())

function update($event: Event): Option | null {
  const eventTarget = $event.target as HTMLSelectElement

  for (const option of props.options) {
    if (option.id == eventTarget.value) {
      return option
    }
  }

  return null
}
</script>
